export default __webpack_public_path__ + "static/media/01n.9eaba3db.jpg";